import { post } from "@/utils/https";

const api = "/xywapi";
const prefix = "/pc";
// 获取专家列表
export async function getPageJudges(param) {
  return await post(`${api}/userJudges/getPageJudges`, param);
}
// 获取专家详情
export async function getJudgesDetails(id) {
  return await post(`${api}/userJudges/getJudgesDetails/${id}`);
}
// 获取专业
export async function getCurrentActivityMajor(data) {
  return await post(`${api}/swMajor/getCurrentActivityMajor`, data);
}
// 获取活动
export async function getActivityListByModel(id) {
  return await post(`${api}/userJudges/getActivityListByModel/${id}`);
}
// 添加评委
export async function addUserJudges(data) {
  return await post(`${prefix}/user/userJudges/addUserJudges`, data);
}
// 编辑评委
export async function updUserJudges(data) {
  return await post(`${prefix}/user/userJudges/updUserJudges`, data);
}
// 删除专家
export async function delUserJudges(id) {
  return await post(`${prefix}/user/userJudges/delUserJudges/${id}`);
}
// 报名服务单位列表
export async function getPageInstitution(data) {
  return await post(`${api}/institution/getPageInstitution`, data);
}
// 申展
export async function addSwExhibition(data) {
  return await post(`${api}/swExhibition/addSwExhibition`, data);
}
